/**
 *
 * @module environmentConfiguration
 *
 */

const deviceFamily = process.env.device_family;
const applicationRuntime = process.env.application_runtime;

let strategy = 'isomorphic';

/**
 *
 * @note runtime specific Storage implementation
 *
 */
if (applicationRuntime === 'trilithium') {
    strategy = `${deviceFamily}/${applicationRuntime}`;
}

module.exports = require(`./${strategy}/environmentConfiguration`);



// WEBPACK FOOTER //
// ./src/services/platforms/environmentConfiguration.js